import { Fragment, useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import TablePagination from "../components/TablePagination";
import OuterBodyModal from "../components/modals/OuterBodyModal";
import { Button } from "react-bootstrap";
import AddEditReceipts from "../components/modals/AddEditReceipts";
import DeleteConfirmationModal from "../components/modals/DeleteConfirmationModal";
import { API_BASE_URL } from "../config";
import ExportButton from "../components/ExportButton";

const Receipts = () => {
  const [receipts, setReceipts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add Receipt");
  const [showDelModal, setShowDelModal] = useState(false);

  const initialFormData = {
    id: "",
    invoiceNo: "",
    invoiceDate: new Date(),
    mor: null,
    ledger: "",
    outstandingBalance: "",
    narration: "",
    amount: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const getReceiptsData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/getReceiptsData`, {
        params: {
          exclude: "createdAt,updatedAt",
        },
      });
      setReceipts(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getReceiptsData();
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
    setShowDelModal(false);
  }, []);

  const onClickAdd = useCallback(() => {
    setModalTitle("Add Receipt");
    setFormData(initialFormData);
    setShowModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickEdit = useCallback(
    (id) => {
      const getReceiptById = async (id) => {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/getReceiptById?id=${id}`
          );
          setFormData({
            ...formData,
            id: response.data.id,
            invoiceNo: response.data.invoice_no,
            invoiceDate: new Date(response.data.invoice_date),
            mor: { value: response.data.mor, label: response.data.mor },
            ledger: response.data.ledger,
            outstandingBalance: response.data.outstanding_balance,
            narration: response.data.narration,
            amount: response.data.amount,
          });
        } catch (error) {
          console.log(error);
        }
      };

      console.log("Edit ID: " + id);
      getReceiptById(id);
      setModalTitle("Edit Receipt");
      setShowModal(true);
    },
    [formData]
  );

  const onClickDel = useCallback(
    (id) => {
      setFormData({
        ...formData,
        id: id,
      });
      setShowDelModal(true);
    },
    [formData]
  );

  const onSubmitReceipts = useCallback(() => {
    setShowModal(false);
    getReceiptsData();
  }, []);

  const handleSubmitAlert = useCallback(
    async (event) => {
      event.preventDefault();
      const clickedButton = event.nativeEvent.submitter;
      const buttonValue = clickedButton.getAttribute("name");

      if (buttonValue === "Yes") {
        console.log("Yes button clicked and id is: " + formData.id);
        try {
          const res = await axios.post(`${API_BASE_URL}/api/delReceipt`, {
            id: formData.id,
          });
          if (res.data.message) {
            console.log(res.data.message);
          } else if (res.data.error) {
            console.log(res.data.error);
          }
        } catch (err) {
          console.log(err);
        }
        setShowDelModal(false);
        getReceiptsData();
      } else if (buttonValue === "No") {
        handleCloseModal();
      }
    },
    [formData, handleCloseModal]
  );

  const memoizedReceipts = useMemo(() => receipts, [receipts]);

  return (
    <>
      {receipts ? (
        <Fragment>
          <Button className="m-3" onClick={onClickAdd}>
            + Add
          </Button>
          <br />
          <ExportButton data={memoizedReceipts} name="Receipts" />
          <TablePagination
            key={JSON.stringify(memoizedReceipts)}
            tabledata={memoizedReceipts}
            initialRowsPerPage="5"
            showEditOption={true}
            showDeleteOption={true}
            onClickEdit={onClickEdit}
            onClickDel={onClickDel}
          ></TablePagination>
          <OuterBodyModal
            modalTitle={modalTitle}
            showModal={showModal}
            handleClose={handleCloseModal}
          >
            <AddEditReceipts
              initialFormData={formData}
              type={modalTitle}
              onHandleSubmit={onSubmitReceipts}
            ></AddEditReceipts>
          </OuterBodyModal>
          <DeleteConfirmationModal
            showModal={showDelModal}
            handleClose={handleCloseModal}
            handleSubmitAlert={handleSubmitAlert}
          />
        </Fragment>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
};

export default Receipts;
